<template>
    <div class="create" v-if="purchase">
        <b-container fluid class="main_layer py-2">
            <b-container>
                <p class="fs-40 fw-600 white-color my-2">Преобразование закупки {{ purchase.reg_number }} в несрочную</p>
            </b-container>
        </b-container>
        <b-container fluid class="my-2">
            <b-container>
                <text-header>Информация о заказчике</text-header>
                <text-row-link :compact="true" :label-cols-lg="4" :label-cols-sm="4" label="Наименование" v-model="purchase.organization.short_name" :router-link="{ name: 'OrganizationShow', params: { id: purchase.organization.id } }" />
                <text-row :compact="true" :label-cols-lg="4" :label-cols-sm="4" label="ИНН" v-model="purchase.organization.inn" />
                <text-row :compact="true" :label-cols-lg="4" :label-cols-sm="4" label="КПП" v-model="purchase.organization.kpp" />
                <text-row :compact="true" :label-cols-lg="4" :label-cols-sm="4" label="ОГРН" v-model="purchase.organization.ogrn" />
                <text-row :compact="true" :label-cols-lg="4" :label-cols-sm="4" label="Юридический адрес" v-model="purchase.organization.post_address" />
                <text-row :compact="true" :label-cols-lg="4" :label-cols-sm="4" label="Дополнительная контактная информация" v-model="purchase.additional_contact_info" v-if="purchase.additional_contact_info" />

                <text-header>Условия закупки</text-header>
                <text-row :compact="true" :label-cols-lg="4" :label-cols-sm="4" label="Предмет закупки" :value="purchase.purchase_name" />
                <text-row :compact="true" :label-cols-lg="4" :label-cols-sm="4" label="Объект закупки" :value="purchase.purchase_object" />
                <text-row :compact="true" :label-cols-lg="4" :label-cols-sm="4" label="Тип закупки" :value="purchase.order_type.name" />
                <text-row :compact="true" :label-cols-lg="4" :label-cols-sm="4" label="Продолжительность закупочной сессии" value="Несрочная" />
                <text-row-date :compact="true" :label-cols-lg="4" :label-cols-sm="4" label="Планируемая дата заключения договора" :value="purchase.planned_contract_date" />
                <text-row-date :compact="true" :label-cols-lg="4" :label-cols-sm="4" label="Планируемая дата исполнения договора" :value="purchase.planned_end_date" />
                <text-row-price :compact="true" :label-cols-lg="4" :label-cols-sm="4" label="Сумма закупки" :value="purchase.start_price" />
                <text-row-single-document :compact="true" :label-cols-lg="4" :label-cols-sm="4" label="Проект договора" :value="contractDraftAttachment" />
                <text-row-documents :compact="true" :label-cols-lg="4" :label-cols-sm="4" label="Дополнительные документы" v-model="additionalDocuments" v-if="additionalDocuments.length > 0" />
                <text-row :compact="true" :label-cols-lg="4" :label-cols-sm="4" label="Информация о возможности и случаях одностороннего расторжения сделки в соответствии с действующим законодательством Российской Федерации" :value="purchase.additional_info" />

                <text-header>Требования к поставщикам</text-header>
                <text-row :compact="true" :label-cols-lg="6" :label-cols-sm="6" label="Отсутствие в реестре недобросовестных поставщиков" :value="purchase.disallow_unfair_suppliers ? 'ДА' : 'НЕТ'" />
                <text-row :compact="true" :label-cols-lg="6" :label-cols-sm="6" label="Участником закупки могут быть только субъекты малого предпринимательства (СМП)" :value="purchase.only_smp ? 'ДА' : 'НЕТ'" />

                <template v-if="purchase.delivery_addresses.length > 0 || purchase.order_plan">
                    <text-header>Условия поставки</text-header>
                    <b-form-group v-if="purchase.delivery_addresses > 0" :label-cols-sm="4" :label-cols-lg="4" label="Адреса для доставки/самовывоза:" label-class="fs-14 grey-color fw-700 d-flex align-items-baseline">
                        <ul>
                            <li v-for="(address, index) in purchase.delivery_addresses" :key="index" class="fs-14 grey-color my-auto col-form-label">{{ address }}</li>
                        </ul>
                    </b-form-group>
                    <text-row :compact="true" :label-cols-lg="4" :label-cols-sm="4" label="График поставки товаров (выполнения работ, оказания услуг)" :value="purchase.order_plan" />
                </template>

                <text-header>Спецификация</text-header>
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th width="1">№</th>
                                <th>Наименование товара (работ, услуг)</th>
                                <th width="160px" class="text-right">Количество</th>
                                <th width="100px" class="text-right">Ед.изм</th>
                                <th width="160px" class="text-right">Цена за ед., руб.</th>
                                <th width="140px" class="text-right">Стоимость, руб.</th>
                            </tr>
                        </thead>
                        <tbody>
                            <fragment v-for="(item, index) in purchase.items" :key="item.id" v-bind="item">
                                <tr :class="visible[index] ? 'border-bottom-0' : ''">
                                    <td>{{ index + 1 }}</td>
                                    <td>
                                        <action-button-small :title="(!visible[index] ? 'Показать' : 'Скрыть') + ' характеристики'" v-b-toggle="'collapse-' + index" :icon="!visible[index] ? 'eye' : 'eye-slash'" />
                                        <b-collapse :id="'collapse-' + index" v-model="visible[index]" class="d-none" />
                                        {{ item.ktru.name }}
                                    </td>
                                    <td style="text-align: right">{{ item.count }}</td>
                                    <td style="text-align: right">
                                        {{ item.ktru.okei_local_symbol ?? '&mdash;' }}
                                    </td>
                                    <td style="text-align: right">{{ $formatPrice(item.price) }}</td>
                                    <td style="text-align: right">{{ $formatPrice(roundToTwoDecimals(item.price * item.count)) }}</td>
                                </tr>
                                <tr v-show="visible[index]">
                                    <td class="align-text-top" colspan="8">
                                        <template v-if="item.ktru">
                                            <p><b>Рег.номер ТРУ:</b> {{ item.ktru.reg_number }}</p>
                                            <p><b>Группа ТРУ:</b> {{ item.ktru.ktru_group_name }}</p>
                                            <p><b>Наименование:</b> {{ item.ktru.name }}</p>
                                            <p><b>Тип:</b> {{ item.ktru.type }}</p>
                                            <p v-if="item.ktru.okpd_code"><b>Код ОКПД2:</b> {{ item.ktru.okpd_code }}</p>
                                            <p v-if="item.ktru.description"><b>Описание:</b> {{ item.ktru.description }}</p>
                                            <p v-if="item.ktru.specs && item.ktru.specs.length > 0"><b>Характеристики:</b></p>
                                            <ul v-if="item.ktru.specs && item.ktru.specs.length > 0">
                                                <li v-for="(spec, specIndex) of item.ktru.specs" :key="index + '_spec_' + specIndex">
                                                    <b>{{ spec.name }}</b> - {{ spec.value }}
                                                </li>
                                            </ul>
                                        </template>
                                        <template v-else>&mdash;</template>
                                    </td>
                                </tr>
                            </fragment>
                        </tbody>
                    </table>
                </div>

                <b-row class="my-3 mt-5" v-if="isPurchaseCreator()">
                    <b-col>
                        <b-button class="mx-2 text-uppercase" variant="custom-outline-secondary" @click="onCancel">Отменить</b-button>
                        <b-button :disabled="!$store.getters.getCanSign" class="text-uppercase mx-2" variant="custom-green" @click="validateForm">Подписать и сохранить</b-button>
                        <template v-if="!$store.getters.getCanSign">
                            <span v-if="$store.getters.getLoginType === 'cert'" class="text-danger pl-3 pt-0 fs-14 w-50 my-auto">Для действия требуется загрузить/заменить МЧД на странице: <router-link :to="{ name: 'UserProfile' }" class="green-link">Данные учетной записи</router-link></span>
                            <span v-else class="text-danger pl-3 pt-0 fs-14 w-50 my-auto">Подписание возможно только при авторизации при помощи ЭЦП</span>
                        </template>
                    </b-col>
                </b-row>
                <b-modal ref="sign-form-modal" v-model="showSignModal" centered no-close-on-backdrop no-close-on-esc scrollable size="lg" title="Подписать заявку на изменение продолжительности" @close="cancelSignModal">
                    <div class="d-block text-left">
                        <b-tabs content-class="mt-3 px-3">
                            <b-tab active>
                                <template slot="title">
                                    <span class="system_link-style fs-16">Форма</span>
                                </template>
                                <h4 class="font-weight-bold">Информация о заказчике</h4>
                                <text-row :compact="true" label="Наименование организации" :value="purchase.organization.short_name" />
                                <text-row :compact="true" label="ИНН" :value="purchase.organization.inn" />
                                <text-row :compact="true" label="КПП" :value="purchase.organization.kpp" />
                                <text-row :compact="true" label="ОГРН" :value="purchase.organization.ogrn" />
                                <text-row :compact="true" label="Адрес" :value="purchase.organization.post_address" />
                                <text-row :compact="true" label="Дополнительная контактная информация" :value="purchase.additional_contact_info" />
                                <hr />
                                <h4 class="font-weight-bold">Условия закупки</h4>
                                <text-row :compact="true" :label-cols-lg="4" :label-cols-sm="4" label="Предмет закупки" :value="purchase.purchase_name" />
                                <text-row :compact="true" :label-cols-lg="4" :label-cols-sm="4" label="Объект закупки" :value="purchase.purchase_object" />
                                <text-row :compact="true" :label-cols-lg="4" :label-cols-sm="4" label="Тип закупки" :value="purchase.order_type.name" />
                                <text-row :compact="true" :label-cols-lg="4" :label-cols-sm="4" label="Продолжительность закупочной сессии" value="Несрочная" />
                                <text-row-date :compact="true" :label-cols-lg="4" :label-cols-sm="4" label="Планируемая дата заключения договора" :value="purchase.planned_contract_date" />
                                <text-row-date :compact="true" :label-cols-lg="4" :label-cols-sm="4" label="Планируемая дата исполнения договора" :value="purchase.planned_end_date" />
                                <text-row-price :compact="true" :label-cols-lg="4" :label-cols-sm="4" label="Сумма закупки" :value="purchase.start_price" />
                                <text-row-single-document :compact="true" :label-cols-lg="4" :label-cols-sm="4" label="Проект договора" :value="contractDraftAttachment" />
                                <text-row-documents :compact="true" :label-cols-lg="4" :label-cols-sm="4" label="Дополнительные документы" v-model="additionalDocuments" v-if="additionalDocuments.length > 0" />
                                <text-row :compact="true" :label-cols-lg="4" :label-cols-sm="4" label="Информация о возможности и случаях одностороннего расторжения сделки в соответствии с действующим законодательством Российской Федерации" :value="purchase.additional_info" />

                                <hr />
                                <h4 class="font-weight-bold">Требования к поставщикам</h4>
                                <text-row :compact="true" :label-cols-lg="6" :label-cols-sm="6" label="Отсутствие в реестре недобросовестных поставщиков" :value="purchase.disallow_unfair_suppliers ? 'ДА' : 'НЕТ'" />
                                <text-row :compact="true" :label-cols-lg="6" :label-cols-sm="6" label="Участником закупки могут быть только субъекты малого предпринимательства (СМП)" :value="purchase.only_smp ? 'ДА' : 'НЕТ'" />

                                <template v-if="purchase.delivery_addresses.length > 0 || purchase.order_plan">
                                    <hr />
                                    <h4 class="font-weight-bold">Условия поставки</h4>
                                    <b-form-group v-if="purchase.delivery_addresses.length > 0" :label-cols-sm="4" :label-cols-lg="4" label="Адреса для доставки/самовывоза:" label-class="fs-14 grey-color fw-700 d-flex align-items-baseline">
                                        <ul>
                                            <li v-for="(address, index) in purchase.delivery_addresses" :key="index" class="fs-14 grey-color my-auto col-form-label">{{ address.address }}</li>
                                        </ul>
                                    </b-form-group>
                                    <text-row :compact="true" :label-cols-lg="4" :label-cols-sm="4" label="График поставки товаров (выполнения работ, оказания услуг)" :value="purchase.order_plan" />
                                </template>

                                <hr />
                                <h4 class="font-weight-bold">Спецификация</h4>
                                <b-form-group v-if="purchase.items.length > 0">
                                    <ul>
                                        <li v-for="(item, index) in purchase.items" :key="index" class="fs-14 grey-color my-auto col-form-label">
                                            {{ item.name }} - {{ item.count }}, {{ item.okei.local_symbol }} <span v-if="item.price">* {{ item.price }}, руб.</span>
                                        </li>
                                    </ul>
                                </b-form-group>
                            </b-tab>
                            <b-tab>
                                <template slot="title">
                                    <span class="system_link-style fs-16">XML</span>
                                </template>
                                <b-form-textarea v-if="!isSignedXml" v-model="formXml" disabled rows="20" no-resize no-auto-shrink wrap="off" class="text-monospace fs-12"></b-form-textarea>
                                <b-form-textarea v-if="isSignedXml" v-model="signedFormXml" disabled rows="20" class="text-monospace fs-12"></b-form-textarea>
                            </b-tab>
                        </b-tabs>
                    </div>
                    <div slot="modal-footer" class="w-100 px-3">
                        <text-row label="Сертификат" :value="certificate?.subjectName" />
                        <b-button variant="custom-outline-secondary" class="mr-2 text-uppercase" @click="cancelSignModal">Отмена</b-button>
                        <b-overlay :show="isSigningXml" v-if="!isSignedXml" rounded opacity="0.6" spinner-small spinner-variant="primary" class="d-inline-block">
                            <b-button variant="custom-green" class="text-uppercase" v-if="!isSignedXml" :disabled="!certificate" @click="signForm">Подписать </b-button>
                        </b-overlay>
                        <b-overlay :show="isDataSending" v-if="isSignedXml" rounded opacity="0.6" spinner-small spinner-variant="primary" class="d-inline-block">
                            <b-button variant="custom-green" class="text-uppercase" v-if="isSignedXml" :disabled="!certificate" @click="sendData">Отправить </b-button>
                        </b-overlay>
                    </div>
                </b-modal>
            </b-container>
        </b-container>
    </div>
</template>

<script>
import Config from '@/rearchitected/core/js/ddriven/application/config/Config';
import roundToTwoDecimals from '../../rearchitected/lib/js/src/misc/roundToTwoDecimals';
import { getCertificate } from 'crypto-pro';
import { $api } from '@/services/backend/api';
import Purchases from '@/services/api/Purchases';

export default {
    name: 'PurchaseCreate',
    data() {
        return {
            tabIndex: 0,
            formXml: '',
            signedFormXml: null,
            isSignedXml: false,
            isSigningXml: false,
            isDataSending: false,
            showSignModal: false,
            certificate: null,
            fileUrl: Config.get('api.config.legacy.url'),
            purchase: null,
            visible: []
        };
    },
    created() {
        this.fillData();
    },
    methods: {
        roundToTwoDecimals,
        cancelSignModal() {
            this.isSignedXml = false;
            this.showSignModal = false;
        },
        async fillData() {
            const response = await Purchases.get(this.$route.params.id);
            this.purchase = response.data.data;
        },
        async validateForm() {
            if (!this.$store.getters.getCanSign) {
                return;
            }
            this.certificate = await getCertificate(this.$store.getters.getCurrentThumbprint);
            if (!this.certificate) {
                return;
            }
            this.showSignForm();
        },
        showSignForm() {
            $api.products.fl44.purchases.getChangeLengthXml(this.purchase.id).then((resp) => {
                this.formXml = resp.xml;
                this.showSignModal = true;
            });
        },
        async signForm() {
            this.isSigningXml = true;
            this.signedFormXml = await $api.signXML(this.formXml);
            this.isSignedXml = !!this.signedFormXml;
            this.isSigningXml = false;
        },
        async sendData() {
            this.isDataSending = true;
            const responseData = await $api.products.fl44.purchases.storeChangeLengthSigned(this.purchase.id, this.signedFormXml, this.certificate);
            this.isDataSending = false;
            if (responseData) {
                this.onCancel();
            }
        },
        onCancel() {
            this.$router.push({ name: 'Cabinet' }).catch(() => {});
        }
    },
    computed: {
        contractDraftAttachment() {
            return this.purchase.documents.find((item) => item.is_main);
        },
        additionalDocuments() {
            return this.purchase.documents.filter((item) => !item.is_main);
        }
    }
};
</script>

<style scoped>
.red-star {
    color: red;
}
.main_layer {
    background-image: url('/images/purchases_head.svg');
    background-repeat: no-repeat;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    min-height: 100px;
}

input::-webkit-input-placeholder {
    color: #959ba4 !important;
    opacity: 0.5 !important;
}

input:-moz-placeholder {
    color: #959ba4 !important;
    opacity: 0.5 !important;
}

input::-moz-placeholder {
    color: #959ba4 !important;
    opacity: 0.5 !important;
}

input:-ms-input-placeholder {
    color: #959ba4 !important;
    opacity: 0.5 !important;
}

input::-ms-input-placeholder {
    color: #959ba4 !important;
    opacity: 0.5 !important;
}

input::placeholder {
    color: #959ba4 !important;
    opacity: 0.5 !important;
}

input {
    border-color: rgba(149, 155, 164, 0.2);
}

.block_head-text {
    font-size: 32px;
    color: var(--grey-color);
    font-weight: 600;
    line-height: 48px;
    margin: 33px 0;
}

.table {
    border-collapse: collapse;
}

.table thead th {
    background: #e4e6e8;
    font-size: 14px;
    font-weight: 600;
    padding: 12px;
    color: var(--grey-color);
}

.table tbody td {
    font-size: 14px;
    /*font-weight: 600;*/
    padding: 12px;
    vertical-align: middle;
    border-bottom: 1px solid #dee2e6;
    color: var(--grey-color);
}

.end_list {
    list-style-type: none;
    padding-left: 0px;
    margin-bottom: 40px;
}

.end_list li {
    margin: 15px 0;
    font-size: 14px;
    color: var(--grey-color);
    position: relative;
}

.end_list li::before {
    content: '';
    position: absolute;
    top: 8px;
    left: -15px;
    width: 5px;
    height: 5px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    background: var(--green-color);
}

.head_register-list {
    color: var(--halfWhite-color);
}
</style>

<style>
.purchase_session {
    position: relative;
}

.purchase_session ul.nav-tabs {
    position: absolute;
    top: -150px;
    width: 100%;
    background: transparent;
}

.purchase_session ul.nav-tabs li {
    width: 25%;
}

.purchase_session ul.nav-tabs li a {
    border: none;
}

.purchase_session .nav-link.active {
    border-bottom: 2px solid #fff;
    background: transparent;
}

.purchase_session .nav-link.active .head_register-list {
    color: #fff;
}
</style>

<style lang="less">
@subtext-color: #777;
@preloader-bg-color: rgba(255, 255, 255, 0.75);
@suggestions-bg-color: #fff;
@subtext-label-color: #f5f5f5;

.box-sizing(@sizing: border-box) {
    -ms-box-sizing: @sizing;
    -moz-box-sizing: @sizing;
    -webkit-box-sizing: @sizing;
    box-sizing: @sizing;
}

.rounded(@radius) {
    -webkit-border-radius: @radius;
    -moz-border-radius: @radius;
    border-radius: @radius;
}

.cross-button-mixin() {
    @cross-padding: 20;
    @cross-ray-width: 10;
    @cross-ray-length: 50 - @cross-padding - @cross-ray-width;
    @svg: "<svg width='100' height='100' xmlns='http://www.w3.org/2000/svg'><g><path d='m@{cross-padding},@{cross-padding}m@{cross-ray-width},0l@{cross-ray-length},@{cross-ray-length}l@{cross-ray-length},-@{cross-ray-length}l@{cross-ray-width},@{cross-ray-width}l-@{cross-ray-length},@{cross-ray-length}l@{cross-ray-length},@{cross-ray-length}l-@{cross-ray-width},@{cross-ray-width}l-@{cross-ray-length},-@{cross-ray-length}l-@{cross-ray-length},@{cross-ray-length}l-@{cross-ray-width},-@{cross-ray-width}l@{cross-ray-length},-@{cross-ray-length}l-@{cross-ray-length},-@{cross-ray-length}l@{cross-ray-width},-@{cross-ray-width}' fill='#999'/></g></svg>";
    @svg64: `new Buffer(@{svg}) .toString('base64') `;
    background: transparent url('data:image/svg+xml;base64,@{svg64}') 50% 50% no-repeat;
    background-size: contain;

    cursor: pointer;
    opacity: 0.8;

    &:hover {
        opacity: 1;
    }
}

.suggestions-nowrap {
    white-space: nowrap;
}

/**
   * Основной INPUT
   */
.suggestions-input {
    // IE9 can't determine border-style until it is specified in stylesheets
    //  border: 1px solid grey;
    .box-sizing();
    width: 100%;

    &::-ms-clear {
        display: none;
    }
}

.suggestions-wrapper {
    position: relative;
    margin: 0;
    padding: 0;
    vertical-align: top;

    //Prevent font scaling in landscape while allowing user zoom
    -webkit-text-size-adjust: 100%;
}

/**
   * Блок в правой части основного INPUT'а
   * В нем показывается иконка ЗАГРУЗКА
   */
.suggestions-addon {
    display: none;
    opacity: 0;
    position: absolute;

    &[data-addon-type='spinner'] {
        background: @preloader-bg-color
            url('data:image/gif;base64,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')
            50% 50% no-repeat;
        .rounded(50%);
    }

    &[data-addon-type='clear'] {
        .cross-button-mixin();
    }
}

/**
   * Выпадающий блок с найденными подсказками
   */
.suggestions-suggestions {
    background: @suggestions-bg-color;
    border: 1px solid #999;
    .box-sizing;
    cursor: default;
    z-index: 9999;

    //Prevent font scaling in landscape while allowing user zoom
    -webkit-text-size-adjust: 100%;

    strong {
        font-weight: normal;
        color: #3399ff;
    }

    &.suggestions-mobile {
        border-style: none;

        .suggestions-suggestion {
            border-bottom: 1px solid #ddd;
        }
    }
}

/**
   * Контейнер для одной подсказки
   */
.suggestions-suggestion {
    padding: 4px 4px;
    overflow: hidden;

    &:hover {
        background: darken(@suggestions-bg-color, 3%);
    }
}

/**
   * Выбранная (активная) подсказка
   */
.suggestions-selected {
    background: darken(@suggestions-bg-color, 6%);

    &:hover {
        background: darken(@suggestions-bg-color, 6%);
    }
}

/**
   * Информационный блок в верхней части выпадашки с подсказками
   */
.suggestions-hint {
    padding: 4px 4px;
    white-space: nowrap;
    overflow: hidden;
    color: @subtext-color;
    font-size: 85%;
    line-height: 20px;
}

/**
   * Ограничения поиска, показываются в левой части основного INPUT'а
   */
.suggestions-constraints {
    list-style: none !important;
    margin: 0 !important;
    padding: 0 !important;
    position: absolute !important;
    white-space: nowrap !important;

    &:empty {
        display: none !important;
    }

    li {
        background: #f8f8f8;
        border: 1px solid #ccc;
        .rounded(3px);
        cursor: default;
        display: inline-block;
        margin: 0 4px 0 0;
        padding: 0 0.5em;

        .suggestions-remove {
            @icon-size: 1em;
            height: @icon-size;
            width: @icon-size;
            display: inline-block;

            margin: 0 0 0 0.25em;
            .cross-button-mixin();
        }

        span {
            vertical-align: middle;
        }
    }
}

/**
   * Дополнительный текст в подсказке, который идет второй строкой
   */
.suggestions-subtext {
    color: @subtext-color;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/**
   * Размещает дополнительный текст в одну строку с основным текстом подсказки
   */
.suggestions-subtext_inline {
    display: inline-block;
    min-width: 6em;
    vertical-align: bottom;
    margin: 0 0.5em 0 0;
}

/**
   * Разделитель нескольких дополнительных текстов
   */
.suggestions-subtext-delimiter {
    display: inline-block;
    width: 2px;
}

/**
   * Выделяет подсказку
   */
.suggestions-subtext_label {
    margin: 0 0 0 0.25em;
    .rounded(3px);
    padding: 0 3px;

    background: @subtext-label-color;
    font-size: 85%;
}

.suggestions-value {
    &[data-suggestion-status='LIQUIDATED'] {
        position: relative;

        &:after {
            position: absolute;
            left: 0;
            right: 0;
            top: 50%;

            border-top: 1px solid rgba(0, 0, 0, 0.4);

            content: '';
        }
    }
}

/**
   * Промо-блок
   */
.suggestions-promo {
    font-size: 85%;
    display: none;
    color: @subtext-color;
    padding: 4px;
    text-align: center;

    a {
        color: @subtext-color;
        display: block;
        filter: grayscale(100%);
        line-height: 20px;
        text-decoration: none;
    }

    a:hover {
        filter: grayscale(0);
    }

    svg {
        height: 20px;
        vertical-align: bottom;
    }
}

.suggestions-promo-desktop {
    position: absolute;
    top: 0;
    right: 0;
    text-align: left;
}
</style>
